import React from 'react';
import { BRAND, brandFont } from '../../lib/brand';

// Shared look for the ops console and its onboarding/settings panels.

export const fontStack = brandFont;

export const inputStyle = {
  width: '100%', padding: '10px 12px', fontSize: '0.9rem', fontFamily: fontStack,
  borderRadius: '6px', border: `1px solid ${BRAND.gray300}`, background: '#fff',
  color: BRAND.ink900, outline: 'none', boxSizing: 'border-box', marginBottom: '12px',
};

export const compactInput = { ...inputStyle, padding: '6px 9px', fontSize: '0.84rem', marginBottom: 0 };

export const btnPrimary = {
  padding: '9px 20px', fontSize: '0.85rem', fontFamily: fontStack, fontWeight: 600,
  backgroundColor: BRAND.ink900, color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer',
};

export const btnSmall = {
  padding: '5px 12px', fontSize: '0.78rem', fontFamily: fontStack, fontWeight: 500,
  background: '#fff', color: BRAND.gray600, border: `1px solid ${BRAND.gray300}`, borderRadius: '6px',
  cursor: 'pointer', marginRight: '6px',
};

export const card = {
  background: BRAND.surface, border: `1px solid ${BRAND.rule}`, borderRadius: '10px',
  boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
};

export const badge = (bg, fg) => ({
  display: 'inline-block', padding: '2px 8px', borderRadius: '10px',
  fontSize: '0.72rem', fontWeight: 600, background: bg, color: fg, marginLeft: '6px',
});

export const hint = { fontSize: '0.78rem', color: BRAND.gray500, margin: '4px 0 0' };

export const errorText = { fontSize: '0.84rem', color: BRAND.danger, margin: '8px 0' };

export const warnBox = {
  fontSize: '0.8rem', color: '#92400e', background: '#fef3c7', border: '1px solid #fde68a',
  borderRadius: '6px', padding: '6px 10px', margin: '6px 0 0',
};

/** A labelled control. `id` ties the label to the input for screen readers and tests. */
export function Field({ id, label, help, children, style }) {
  return (
    <div style={{ marginBottom: '12px', ...style }}>
      <label htmlFor={id} style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: BRAND.ink900, marginBottom: '4px' }}>
        {label}
      </label>
      {children}
      {help && <p style={hint}>{help}</p>}
    </div>
  );
}

/** Errors from a 400 {error, errors[]} response, one per line. */
export function ErrorList({ error }) {
  if (!error) return null;
  const lines = Array.isArray(error) ? error : [error];
  return (
    <div role="alert" style={errorText}>
      {lines.map((e) => <div key={e}>{e}</div>)}
    </div>
  );
}

/** Message(s) from an api() result that failed. */
export function apiErrors(data, fallback) {
  if (data && Array.isArray(data.errors) && data.errors.length) return data.errors;
  return (data && data.error) || fallback;
}
